<template>
  <div>
    <div class="section-title" style="text-align: center;margin-top: 40px;">
      Zmiana hasła
    </div>

    <v-container class="container mt-10 mb-12 pb-12 ">
      <v-row justify="center" align="baseline" class="">
        <v-col cols="12" sm="6" md="4" lg="4" xl="3">
          <v-card shaped elevation="5" class="card">
            <v-container class="py-10 px-10 ">
              <ValidationObserver v-slot="{ handleSubmit }">
                <v-form
                  ref="form"
                  style="display: flex; flex-direction: column; gap:20px; align-items: center;  justify-content: center; margin-top: 20px;"
                  @submit.prevent="handleSubmit(handleChangePassword)"
                >
                  <VTextFieldWithValidation
                    label="Nowe hasło"
                    type="password"
                    color="white"
                    placeholder="Wpisz hasło"
                    v-model="formData.password"
                  />
                  <VTextFieldWithValidation
                    label="Powtórz nowe hasło"
                    type="password"
                    color="white"
                    placeholder="Powtórz hasło"
                    v-model="formData.confirmPassword"
                  />
                  <button type="submit" class="primary-button ">
                    Zmień hasło
                  </button>
                </v-form>
              </ValidationObserver>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import VTextFieldWithValidation from "../components/inputs/VTextFieldWithValidation.vue";

export default {
  metaInfo: {
    title: "Dagajoga zmiana hasła - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  components: {
    VTextFieldWithValidation,
  },
  data() {
    return {
      formData: {
        email: "",
        password: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    async handleChangePassword() {
      if (!this.formData.password || !this.formData.confirmPassword) {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message: "Uzupełnij wymagane pola do zmiany hasła",
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        return;
      }
      if (this.formData.password !== this.formData.confirmPassword) {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message: "Podane hasła muszą być identyczne",
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        return;
      }
      const code = this.$router.currentRoute.query.code;
      const password = this.formData.password;
      const confirmPassword = this.formData.confirmPassword;
      const data = { code, password, confirmPassword };
      try {
        let response;
        if (code) {
          response = await this.$store.dispatch("auth/changePassword", data);
        } else {
          response = await this.$store.dispatch("auth/changeOwnPassword", data);
        }
        if (response) {
          this.$router.push({ name: "Courses" });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.transparent-bg {
  padding: 50px;
  border-radius: 15px;
  background-color: rgba(255, 255, 255, 0.664);
}
i {
  font-size: 120px;
}
h1 {
  margin-bottom: 30px;
}
.btn-gradient {
  width: fit-content;
  padding: 15px 25px;
  border-radius: 30px;
  font-size: 1.4rem;
}

.background {
  color: #fff;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%);
  width: fit-content;
  padding: 15px 25px;
  border-radius: 30px;
  font-size: 1.4rem;
}

.card {
  background-color: #d9d9d9 !important;
  color: #54514c;
  border-radius: 32px !important;
  position: relative;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5 !important;
}

.center {
  display: flex;
  justify-content: center;
  margin-right: 20px;
  margin-top: 15px;
}
a {
  text-decoration: none;
}
form {
  display: flex;
  flex-direction: column;
}
input {
  border-bottom: 1px solid black;
  color: black;
  width: 80%;
  margin-bottom: 30px;
  padding: 10px 0;
}
label {
  font-weight: 350;
  font-size: 1.1rem;
}
.flexit {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
h5 {
  background: #ce4257;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  margin-top: -25px;
  margin-bottom: 15px;
}
@media screen and (max-width: 600px) {
  input {
    width: 100%;
  }
  h1 {
    font-size: 1.6rem;
  }
}
</style>
